import makeRoutes from "@/routes/Base/Route";

export default [
    ...makeRoutes('rnds').map(route => {
        return {
            ...route,
            meta: {permission: route.name}
        }
    }),
    {
        path: `/rnds/show/:id`,
        name: `rnds.show`,
        component: () => import(`@/pages/rnds/Show`),
        meta: {permission: `rnds.show`}
    },
]